import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../commonFields";

export const featuresOverviewCardsBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Features Overview Cards",
  image:
    "https://icons.veryicon.com/png/o/internet--web/web-icon-4/visual-platform-icon_-grid-layout-1.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "featureCards",
      type: "list",
      required: false,
      subFields: [
        {
          name: "cardContent",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature headline</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Feature description</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          name: "featureContent",
          type: "uiBlocks",
          defaultValue: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed feature content goes here.",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                },
              ],
            },
          ],
        },
        {
          name: "button",
          type: "object",
          required: false,
          subFields: [
            {
              name: "viewMore",
              type: "string",
              localized: true,
              required: true,
              defaultValue: {
                "@type": "@builder.io/core:LocalizedValue",
                Default: "View More",
              },
            },
            {
              name: "viewLess",
              type: "string",
              localized: true,
              required: true,
              defaultValue: {
                "@type": "@builder.io/core:LocalizedValue",
                Default: "View Less",
              },
            },
            DLT_FIELD,
            DLD_FIELD,
          ],
          defaultValue: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "",
            dld: "",
          },
        },
      ],
      defaultValue: [
        {
          cardContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card 1 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature 1</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Description for feature 1</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          featureContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature 1 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed content for feature 1",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                  responsiveStyles: {
                    large: {
                      color: "var(--color-body-primary)",
                    },
                  },
                },
              ],
            },
          ],
          button: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "DLT Feature 1",
            dld: "DLD Feature 1",
          },
        },
        {
          cardContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card 2 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature 2</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Description for feature 2</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          featureContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature 2 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed content for feature 2",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                  responsiveStyles: {
                    large: {
                      color: "var(--color-body-primary)",
                    },
                  },
                },
              ],
            },
          ],
          button: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "DLT Feature 2",
            dld: "DLD Feature 2",
          },
        },
        {
          cardContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card 3 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature 3</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Description for feature 3</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          featureContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature 3 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed content for feature 3",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                  responsiveStyles: {
                    large: {
                      color: "var(--color-body-primary)",
                    },
                  },
                },
              ],
            },
          ],
          button: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "DLT Feature 3",
            dld: "DLD Feature 3",
          },
        },
        {
          cardContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card 4 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature 4</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Description for feature 4</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          featureContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature 4 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed content for feature 4",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                  responsiveStyles: {
                    large: {
                      color: "var(--color-body-primary)",
                    },
                  },
                },
              ],
            },
          ],
          button: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "DLT Feature 4",
            dld: "DLD Feature 4",
          },
        },
        {
          cardContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card 5 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature 5</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Description for feature 5</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          featureContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature 5 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed content for feature 5",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                  responsiveStyles: {
                    large: {
                      color: "var(--color-body-primary)",
                    },
                  },
                },
              ],
            },
          ],
          button: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "DLT Feature 5",
            dld: "DLD Feature 5",
          },
        },
        {
          cardContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Card 6 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Headline",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<h3>Feature 6</h3>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-subhead-m, 1.5rem)",
                          lineHeight:
                            "var(--text-subhead-m--line-height, 2.25rem)",
                          fontWeight: "var(--font-weight-bold, 700)",
                          color: "var(--color-headline)",
                        },
                        xsmall: {
                          fontSize: "var(--text-subhead-xs, 1.25rem)",
                          lineHeight:
                            "var(--text-subhead-xs--line-height, 1.75rem)",
                        },
                      },
                    },
                  ],
                },
                {
                  "@type": "@builder.io/sdk:Element",
                  layerName: "Description",
                  children: [
                    {
                      "@type": "@builder.io/sdk:Element",
                      component: {
                        name: "Text",
                        options: {
                          text: {
                            "@type": "@builder.io/core:LocalizedValue",
                            Default: "<p>Description for feature 6</p>",
                          },
                        },
                      },
                      meta: {
                        localizedTextInputs: ["text"],
                        "transformed.text": "localized",
                      },
                      responsiveStyles: {
                        large: {
                          fontSize: "var(--text-body-m, 1.125rem)",
                          lineHeight: "var(--text-body-m--line-height, 2rem)",
                          fontWeight: "var(--font-weight-normal, 400)",
                          color: "var(--color-subhead)",
                        },
                        xsmall: {
                          fontSize: "var(--text-body-s, 1rem)",
                          lineHeight: "var(--text-body-s--line-height, 1.5rem)",
                        },
                      },
                    },
                  ],
                },
              ],
            },
          ],
          featureContent: [
            {
              "@type": "@builder.io/sdk:Element",
              layerName: "Feature 6 Content",
              children: [
                {
                  "@type": "@builder.io/sdk:Element",
                  component: {
                    name: "Text",
                    options: {
                      text: {
                        "@type": "@builder.io/core:LocalizedValue",
                        Default: "Detailed content for feature 6",
                      },
                    },
                  },
                  meta: {
                    localizedTextInputs: ["text"],
                    "transformed.text": "localized",
                  },
                  responsiveStyles: {
                    large: {
                      color: "var(--color-body-primary)",
                    },
                  },
                },
              ],
            },
          ],
          button: {
            viewMore: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View More",
            },
            viewLess: {
              "@type": "@builder.io/core:LocalizedValue",
              Default: "View Less",
            },
            dlt: "DLT Feature 6",
            dld: "DLD Feature 6",
          },
        },
      ],
    },
  ],
  requiresParent: {
    message:
      "This component must be nested within the Features Overview component",
    component: "Features Overview",
  },
  noWrap: true,
  defaults: {
    responsiveStyles: {
      large: {
        paddingLeft: "var(--spacing-6, 24px)",
        paddingRight: "var(--spacing-6, 24px)",
        marginRight: "auto",
        marginLeft: "auto",
        maxWidth: "1280px",
        width: "100%",
      },
      medium: {
        paddingLeft: "0px",
        paddingRight: "0px",
      },
    },
  },
};
